(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
    window.LuciaVariantLimits = window.LuciaVariantLimits || {};

    window.LuciaRegisterVariantLimit = function (variantId, limit) {
      if (!variantId) {
        return;
      }
      var n = parseInt(limit, 10);
      window.LuciaVariantLimits[String(variantId)] = Number.isFinite(n) && n >= 1 ? n : 99;
    };

    function getVariantLimit(variantId) {
      var stored = window.LuciaVariantLimits[String(variantId)];
      if (stored != null) {
        return stored;
      }
      return 99;
    }

    var overlay = document.getElementById('cart-overlay');
    var drawer = document.getElementById('cart-drawer');
    var closeBtn = document.getElementById('cart-close');
    var bodyEl = document.getElementById('cart-drawer-body');
    var footer = document.getElementById('cart-footer');

    var tacaTemplate = document.getElementById('cart-taca-svg');
    var TACA_SVG = tacaTemplate && tacaTemplate.content.querySelector('svg')
      ? tacaTemplate.content.querySelector('svg').outerHTML
      : '';

    var TRASH_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"></path><path d="M10 11v6"></path><path d="M14 11v6"></path><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"></path></svg>';

    var emptyText = drawer.dataset.emptyText;
    var continueText = drawer.dataset.continueText;
    var removeLabel = drawer.dataset.removeLabel;
    var updatingLabel = drawer.dataset.updatingLabel;
    var checkoutEl = document.getElementById('cart-checkout');
    var checkoutHref = checkoutEl ? checkoutEl.getAttribute('href') || '/checkout' : '/checkout';
    var pendingUpdates = 0;
    var QUANTITY_DEBOUNCE_MS = 400;
    var linePending = {};

    function openCart() {
      fetchAndRenderCart().then(function () {
        overlay.classList.add('is-visible');
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        overlay.setAttribute('aria-hidden', 'false');
        document.body.classList.add('cart-is-open');
      });
    }

    function closeCart() {
      flushAllPendingLineUpdates();
      overlay.classList.remove('is-visible');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cart-is-open');
    }

    function formatMoney(cents) {
      return 'R$' + (cents / 100).toFixed(2).replace('.', ',');
    }

    function escapeHtml(str) {
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function buildEmptyState() {
      return (
        '<div class="cart-drawer__empty">' +
        '  <div class="cart-drawer__empty-row">' +
        '    <span class="cart-drawer__taca">' + TACA_SVG + '</span>' +
        '    <p class="cart-drawer__empty-text">' + escapeHtml(emptyText) + '</p>' +
        '    <span class="cart-drawer__taca">' + TACA_SVG + '</span>' +
        '  </div>' +
        '  <button type="button" class="cart-drawer__continue" id="cart-continue">' +
        '    ' + escapeHtml(continueText) +
        '  </button>' +
        '</div>'
      );
    }

    function totalsByVariantId(cart) {
      var map = {};
      if (!cart || !cart.items) {
        return map;
      }
      cart.items.forEach(function (it) {
        var v = String(it.variant_id);
        map[v] = (map[v] || 0) + it.quantity;
      });
      return map;
    }

    function buildItem(item, variantTotals) {
      var vid = String(item.variant_id);
      var maxQty = getVariantLimit(vid);
      var totalForVariant = variantTotals[vid] != null ? variantTotals[vid] : item.quantity;
      var plusDisabled = totalForVariant >= maxQty;

      var variantTitle =
        item.variant_title && item.variant_title !== 'Default Title'
          ? '<br>' + escapeHtml(item.variant_title.toUpperCase())
          : '';

      var imgUrl = '';
      if (item.featured_image && item.featured_image.url) {
        var base = item.featured_image.url.split('?')[0];
        imgUrl = base + '?width=120';
      }
      var imageHtml = imgUrl
        ? '<img src="' + imgUrl + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">'
        : '';

      return (
        '<li class="cart-drawer__item" data-key="' +
        escapeHtml(item.key) +
        '" data-variant-id="' +
        escapeHtml(vid) +
        '" data-bottle-limit="' +
        maxQty +
        '">' +
        '  <div class="cart-item__image">' + imageHtml + '</div>' +
        '  <div class="cart-item__info">' +
        '    <div class="cart-item__header">' +
        '      <p class="cart-item__title">' + escapeHtml(item.product_title.toUpperCase()) + variantTitle + '</p>' +
        '      <p class="cart-item__price">' + formatMoney(item.final_price) + '</p>' +
        '    </div>' +
        '    <div class="cart-item__actions">' +
        '      <div class="cart-item__qty">' +
        '          <button type="button" class="cart-item__qty-btn cart-item__qty-btn--minus" data-key="' + escapeHtml(item.key) + '">-</button>' +
        '          <span class="cart-item__qty-value">' + item.quantity + '</span>' +
        '          <button type="button" class="cart-item__qty-btn cart-item__qty-btn--plus"' +
        (plusDisabled ? ' disabled' : '') +
        ' data-key="' +
        escapeHtml(item.key) +
        '" data-variant-id="' +
        escapeHtml(vid) +
        '" data-bottle-limit="' +
        maxQty +
        '">+</button>' +
        '      </div>' +
        '      <div class="cart-item__remove-slot">' +
        '        <button type="button" class="cart-item__remove" data-key="' + escapeHtml(item.key) + '" aria-label="' + escapeHtml(removeLabel) + '">' +
        '          ' + TRASH_SVG +
        '        </button>' +
        '        <span class="cart-item__spinner" hidden aria-label="' + escapeHtml(drawer.dataset.updatingLabel || '') + '"></span>' +
        '      </div>' +
        '    </div>' +
        '  </div>' +
        '</li>'
      );
    }

    function getLineQuantity(lineEl) {
      var valueEl = lineEl && lineEl.querySelector('.cart-item__qty-value');
      return parseInt(valueEl && valueEl.textContent, 10) || 0;
    }

    function getVariantTotalInDrawer(variantId) {
      var total = 0;
      bodyEl.querySelectorAll('.cart-drawer__item[data-variant-id="' + variantId + '"]').forEach(
        function (row) {
          total += getLineQuantity(row);
        }
      );
      return total;
    }

    function setCheckoutDisabled(disabled) {
      if (!checkoutEl) {
        return;
      }
      if (disabled) {
        checkoutEl.classList.add('cart-drawer__checkout--disabled');
        checkoutEl.setAttribute('aria-disabled', 'true');
        checkoutEl.setAttribute('tabindex', '-1');
        checkoutEl.removeAttribute('href');
      } else {
        checkoutEl.classList.remove('cart-drawer__checkout--disabled');
        checkoutEl.removeAttribute('aria-disabled');
        checkoutEl.removeAttribute('tabindex');
        checkoutEl.setAttribute('href', checkoutHref);
      }
    }

    function beginCartUpdate() {
      pendingUpdates += 1;
      setCheckoutDisabled(true);
    }

    function endCartUpdate() {
      pendingUpdates = Math.max(0, pendingUpdates - 1);
      if (pendingUpdates === 0) {
        setCheckoutDisabled(false);
      }
    }

    function setLineUpdating(lineEl, isUpdating) {
      if (!lineEl) {
        return;
      }
      lineEl.classList.toggle('cart-drawer__item--updating', isUpdating);
      var spinner = lineEl.querySelector('.cart-item__spinner');
      if (spinner) {
        spinner.hidden = !isUpdating;
      }
      lineEl.querySelectorAll('.cart-item__qty-btn').forEach(function (btn) {
        btn.disabled = isUpdating;
      });
    }

    function flushLineUpdate(key) {
      var pending = linePending[key];
      if (!pending) {
        return;
      }
      clearTimeout(pending.timer);
      delete linePending[key];
      commitLineUpdate(pending.key, pending.targetQty, pending.lineEl);
    }

    function flushAllPendingLineUpdates() {
      Object.keys(linePending).slice().forEach(flushLineUpdate);
    }

    function queueQuantityChange(key, quantity, lineEl) {
      if (!lineEl || !key) {
        return;
      }

      if (lineEl.classList.contains('cart-drawer__item--updating')) {
        return;
      }

      applyOptimisticUpdate(lineEl, quantity);

      var pending = linePending[key];
      if (!pending) {
        pending = { key: key };
        linePending[key] = pending;
      }
      pending.targetQty = quantity;
      pending.lineEl = lineEl;

      clearTimeout(pending.timer);
      pending.timer = setTimeout(function () {
        flushLineUpdate(key);
      }, QUANTITY_DEBOUNCE_MS);
    }

    function setLineQuantity(lineEl, quantity) {
      var valueEl = lineEl.querySelector('.cart-item__qty-value');
      if (valueEl) {
        valueEl.textContent = String(quantity);
      }
    }

    function syncVariantPlusButtons(variantId) {
      var lineEl = bodyEl.querySelector('.cart-drawer__item[data-variant-id="' + variantId + '"]');
      if (!lineEl) {
        return;
      }
      var maxQty = parseInt(lineEl.getAttribute('data-bottle-limit'), 10);
      if (!Number.isFinite(maxQty)) {
        maxQty = getVariantLimit(variantId);
      }
      var atLimit = getVariantTotalInDrawer(variantId) >= maxQty;
      bodyEl.querySelectorAll('.cart-drawer__item[data-variant-id="' + variantId + '"]').forEach(
        function (row) {
          if (row.classList.contains('cart-drawer__item--updating')) {
            return;
          }
          var plusBtn = row.querySelector('.cart-item__qty-btn--plus');
          if (plusBtn) {
            plusBtn.disabled = atLimit;
          }
        }
      );
    }

    function updateHeaderCountOptimistic(delta) {
      document.querySelectorAll('.header__cart-count').forEach(function (el) {
        var match = el.textContent.match(/\((\d+)\)/);
        var current = match ? parseInt(match[1], 10) : 0;
        var next = Math.max(0, current + delta);
        el.textContent = '(' + next + ')';
      });
    }

    function applyOptimisticUpdate(lineEl, nextQuantity) {
      var previousQty = getLineQuantity(lineEl);
      var delta = nextQuantity - previousQty;

      setLineQuantity(lineEl, nextQuantity);
      updateHeaderCountOptimistic(delta);

      var variantId = lineEl.getAttribute('data-variant-id');
      syncVariantPlusButtons(variantId);

      if (nextQuantity === 0) {
        lineEl.classList.add('cart-drawer__item--removing');
      } else {
        lineEl.classList.remove('cart-drawer__item--removing');
      }
    }

    function renderCart(cart) {
      if (Object.keys(linePending).length) {
        flushAllPendingLineUpdates();
      }

      if (!cart || !Array.isArray(cart.items)) {
        return fetchCart().then(renderCart);
      }

      var itemCount =
        cart.item_count != null
          ? cart.item_count
          : cart.items.reduce(function (sum, item) {
              return sum + item.quantity;
            }, 0);

      if (itemCount === 0) {
        bodyEl.innerHTML = buildEmptyState();
        footer.style.display = 'none';
        var continueBtn = document.getElementById('cart-continue');
        if (continueBtn) {
          continueBtn.addEventListener('click', closeCart);
        }
      } else {
        cart.items.forEach(function (item) {
          window.LuciaRegisterVariantLimit(item.variant_id, getVariantLimit(item.variant_id));
        });

        var variantTotals = totalsByVariantId(cart);
        var itemsHtml = cart.items
          .map(function (item) {
            return buildItem(item, variantTotals);
          })
          .join('');
        bodyEl.innerHTML = '<ul class="cart-drawer__items">' + itemsHtml + '</ul>';
        footer.style.display = 'block';
      }

      document.querySelectorAll('.header__cart-count').forEach(function (el) {
        el.textContent = '(' + itemCount + ')';
      });

      document.dispatchEvent(
        new CustomEvent('lucia:cart:updated', { detail: { cart: cart } })
      );
    }

    function bindCartItemEvents() {
      if (bodyEl.dataset.cartItemsBound === 'true') {
        return;
      }
      bodyEl.dataset.cartItemsBound = 'true';

      bodyEl.addEventListener('click', function (event) {
        var lineEl = event.target.closest('.cart-drawer__item');
        if (lineEl && lineEl.classList.contains('cart-drawer__item--updating')) {
          return;
        }

        var removeBtn = event.target.closest('.cart-item__remove');
        if (removeBtn) {
          var removeKey = removeBtn.getAttribute('data-key');
          var removeLine = removeBtn.closest('.cart-drawer__item');
          if (removeKey && removeLine) {
            queueQuantityChange(removeKey, 0, removeLine);
          }
          return;
        }

        var qtyBtn = event.target.closest('.cart-item__qty-btn');
        if (!qtyBtn || qtyBtn.disabled) {
          return;
        }

        if (!lineEl) {
          lineEl = qtyBtn.closest('.cart-drawer__item');
        }
        if (!lineEl) {
          return;
        }

        var lineKey = qtyBtn.getAttribute('data-key') || lineEl.getAttribute('data-key');
        if (!lineKey) {
          return;
        }

        var currentLineQty = getLineQuantity(lineEl);
        var variantId = lineEl.getAttribute('data-variant-id');
        var isPlus = qtyBtn.classList.contains('cart-item__qty-btn--plus');
        var nextQuantity;

        if (isPlus) {
          var maxQty = parseInt(lineEl.getAttribute('data-bottle-limit'), 10);
          if (!Number.isFinite(maxQty)) {
            maxQty = getVariantLimit(variantId);
          }
          var variantTotal = getVariantTotalInDrawer(variantId);
          if (variantTotal >= maxQty) {
            return;
          }
          nextQuantity = currentLineQty + 1;
        } else {
          nextQuantity = Math.max(0, currentLineQty - 1);
        }

        if (nextQuantity === currentLineQty) {
          return;
        }

        queueQuantityChange(lineKey, nextQuantity, lineEl);
      });
    }

    function fetchCart() {
      return fetch('/cart.js').then(function (r) {
        return r.json();
      });
    }

    function fetchAndRenderCart() {
      return fetchCart().then(function (cart) {
        renderCart(cart);
        return cart;
      });
    }

    function commitLineUpdate(key, quantity, lineEl) {
      if (lineEl) {
        setLineUpdating(lineEl, true);
      }
      beginCartUpdate();

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity }),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok || !data || !Array.isArray(data.items)) {
              return fetchCart();
            }
            return data;
          });
        })
        .then(renderCart)
        .catch(function () {
          return fetchCart().then(renderCart);
        })
        .finally(function () {
          endCartUpdate();
        });
    }

    bindCartItemEvents();

    closeBtn.addEventListener('click', closeCart);
    overlay.addEventListener('click', closeCart);

    document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
      btn.addEventListener('click', openCart);
    });

    window.CartDrawer = { open: openCart, close: closeCart };
  })();
  } catch(e) { console.error(e); }
})();

})();
